export enum IconTypes {
  Device,
  User,
  Dashboard,
  Graph,
  List
}

export type TableIconType = IconTypes | undefined;
